module.exports = __webpack_public_path__ + "img/青年大学习.7faaaafd.svg";